import React from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { CourseDetails } from './CourseDetails';
import { FAQ } from './FAQ';
import { Guarantee } from './Guarantee';
import { CallToAction } from './CallToAction';
import { Footer } from './Footer';
export const Advertorial = () => {
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800" data-id="element-6">
      <Header data-id="element-7" />
      <Problem data-id="element-8" />
      <Solution data-id="element-9" />
      <Testimonials data-id="element-10" />
      <CourseDetails data-id="element-11" />
      <FAQ data-id="element-12" />
      <Guarantee data-id="element-13" />
      <CallToAction data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
};